import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
const PaymentNotPaid = ({ message }) => {
  return (
    <div className="container">
      <div className="row justify-content-center align-items-center vh-100">
        <div className="col-md-5 col-12">
          <Card className="shadow text-center">
            <Card.Body>
              <div className="heading">
                <h1>oops!</h1>
              </div>
              <p className="mb-4">
                You have not subscribed any plan or subscription is expired.
                Kindly purchase your subscription
              </p>

              <div className="d-flex justify-content-center gap-3">
                <Link to="/subscription" className="btn btn-primary">
                  Go Back Subscription
                </Link>
                <Link to="/team" className="btn btn-secondary">
                  Go Back
                </Link>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default PaymentNotPaid;
